export const isFreeStockRow = (row) =>
  row?.status_type === "stock" &&
  !row?.is_adjustment_held &&
  row?.isnottransferable !== true &&
  row?.isnottransferable !== "true" &&
  row?.rowclass !== "row-inactive";

// Can this row go on a stock transfer? Orders and cross-location reserves only when they have
// a second location in the location column, meaning they still have to move to their destined location.
export const canTransferRow = (row) => {
  if (
    row?.status_type === "transit" ||
    row?.isnottransferable === true ||
    row?.isnottransferable === "true"
  ) {
    return false;
  }
  if (["custom_order", "repair_order", "reserve"].includes(row?.status_type)) {
    return Boolean(row?.warehouse_location_name);
  }
  return true;
};

// All rows share one location: select all takes the free stock rows and skips the rest.
// Those rows must also share a warehouse, as the row lock requires.
export const canSelectFreeStockRows = (list) => {
  if (!list?.length) return false;
  const locations = new Set(list.map((row) => row?.location_id));
  const freeRows = list.filter(isFreeStockRow);
  const warehouses = new Set(freeRows.map((row) => row?.warehouse_id).filter(Boolean));
  return locations.size === 1 && freeRows.length > 0 && warehouses.size <= 1;
};
